import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const features = [
  {
    title: '10+ Years Experience',
    desc: 'Our master detailers have spent over a decade perfecting the art of automotive restoration.',
    icon: FiIcons.FiClock
  },
  {
    title: 'Premium Products',
    desc: 'We exclusively use professional-grade, thoroughly tested compounds and coatings.',
    icon: FiIcons.FiStar
  },
  {
    title: 'Fully Insured Studio',
    desc: 'Rest easy knowing your investment is completely protected while in our care.',
    icon: FiIcons.FiShield
  },
  {
    title: 'Obsessive Quality Control',
    desc: 'Every vehicle undergoes a strict multi-point inspection before it returns to you.',
    icon: FiIcons.FiCheckCircle
  }
];

const WhyChooseUs = () => {
  return (
    <section className="py-24 bg-bgDark border-y border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="space-y-8"
          >
            <div>
              <span className="text-accent text-sm font-bold tracking-widest uppercase mb-2 block">The Obsidian Standard</span>
              <h2 className="text-4xl md:text-5xl font-heading font-bold mb-6">Why Trust Us With Your Vehicle?</h2>
              <p className="text-textMuted text-lg leading-relaxed">
                Located in the heart of Montreal, Obsidian Auto Spa was founded on a simple principle: delivering absolute perfection. We treat every vehicle like a rare exotic, ensuring the highest level of care and precision.
              </p>
            </div>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {features.map((feature, idx) => (
                <div key={idx} className="glass-card p-6 border border-white/5 hover:border-accent/30 transition-colors">
                  <SafeIcon icon={feature.icon} className="text-accent text-3xl mb-4" />
                  <h4 className="font-bold text-lg mb-2">{feature.title}</h4>
                  <p className="text-sm text-textMuted">{feature.desc}</p>
                </div>
              ))}
            </div>
          </motion.div>
          
          <motion.div 
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="aspect-[4/5] rounded-2xl overflow-hidden relative">
              <img 
                src="https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?auto=format&fit=crop&q=80" 
                alt="Luxury Car Detailing" 
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-bgDark/80 to-transparent"></div>
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-6 -left-6 bg-primary p-6 rounded-xl border border-white/10 shadow-2xl">
              <div className="flex items-center gap-4">
                <div className="bg-accent/20 p-3 rounded-full">
                  <SafeIcon icon={FiIcons.FiAward} className="text-accent text-2xl" />
                </div>
                <div>
                  <p className="text-2xl font-bold text-white">5.0</p>
                  <p className="text-xs text-textMuted uppercase tracking-wider">Average Rating</p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;